import React, { ReactNode } from "react";
import { useEffect, useState } from "react";
import { Dialog } from '@alifd/next';
//@ts-ignore
import $i18n from '@/i18n';
import JsAPIApplyTable from "./applyTable";

import { openJsapiAuthChannel } from './index'

interface DialogProps {
  spaceId: string;
  appId: string;
  title: ReactNode | undefined;
  openJsApiAuthChannels: openJsapiAuthChannel[],
  refresh: () => void
}
export const useApplyDialog = () => {
  const [open, setOpen] = useState<DialogProps | undefined>(undefined);

  let dialogInstalce: any = null
  const close = () => {
    console.log('close')
    setOpen((state) => undefined)
    dialogInstalce.hide()
  }


  useEffect(() => {
    if (open) {
      dialogInstalce = Dialog.show({
        v2: true,
        width: 800,
        centered: true,
        hasMask: true,
        footerActions: ['cancel', 'ok'],
        title: <div> {open?.title}</div>,
        footer: false,
        content: <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', overflow: 'hidden' }}>
          <JsAPIApplyTable closeDialog={close} openJsApiAuthChannels={open.openJsApiAuthChannels} spaceId={open.spaceId || ''} appId={open.appId} refresh={open.refresh} />
        </div>,
      })
    }
  }, [open])


  return {
    openDialog: (props: DialogProps) => setOpen({ ...props }),
    closeDialog: close,
  };
};


